import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: {
          general: {
            select_option: 'Select an option',
            required: 'Required',
            wrong_format: 'Wrong format',
            email_not_match: 'The confirmation email does not match',
            button_update: 'Update',
            cancel_reservation: 'Cancel reservation',
            text_not_close: 'Not, close',
            text_yes_cancel: 'Yes, cancel',
            text_updated_reservation: 'Updated reservation',
            text_return: 'Return',
            text_must_be_number: 'Must be a number',
            text_hour_within_schedule: 'The time must be within the schedule',
            text_cancelled_reservation: 'Cancelled reservation',
          },
          reserve_confirmation: {
            title_chunk_1: 'Hi',
            title_chunk_2: 'Booking',
            title_chunk_3: 'confirmed for',
            text_email_sent: `We have sent an email confirming your reservation,
             if you don't see it in your inbox, please check your 
             SPAM folder and mark it as junk mail.`,
            text_reservation_summary: 'Your reservation has been confirmed',
            text_reservation_code: 'Reservation code',
            text_day: 'Day',
            text_hour: 'Hour',
            text_location: 'Location',
            text_people: 'People',
            text_share_whatsapp: 'Share on Whatsapp',
            calendar_add: 'Add to my calendar',
            series_title_one: 'Your booking is confirmed',
            series_title_many: 'You have {{count}} confirmed bookings',
            series_title_past: 'Your bookings were',
            series_title_none: 'All the dates of this series are cancelled',
            series_people_one: '1 person',
            series_people_many: '{{count}} people',
            series_all_day: 'all day',
            series_code_hint: 'With code {{code}} you can see, change or cancel any of your dates.',
            series_cancelled_one: 'Not included, cancelled: {{dates}}.',
            series_cancelled_many: 'Not included, {{count}} cancelled: {{dates}}.',
            series_past_one: 'Already held: {{dates}}.',
            series_past_many: 'Already held ({{count}}): {{dates}}.',
            series_share_intro: 'Your bookings at {{company}}:',
            calendar_pick: 'Choose your calendar',
            calendar_google: 'Google Calendar',
            calendar_apple: 'Apple Calendar',
            calendar_outlook: 'Outlook (personal)',
            calendar_office: 'Outlook / Microsoft 365 (work)',
            calendar_yahoo: 'Yahoo Calendar',
            calendar_ics: 'Download file (.ics)',
            calendar_ics_hint: 'For any other calendar app',
            calendar_series: 'This reservation repeats {{count}} times. The .ics file adds every date at once; the other options add only this one.',
            calendar_downloaded: 'File ready. Open it to add the reservation to your calendar.',
            calendar_cancelled: 'This reservation is cancelled. The file removes it from your calendar.',
            calendar_iframe_hint: "Didn't download? Open your reservation in a new tab and try again.",
          },
          search_reservation_form: {
            title: 'Enter your reservation code to validate it and be able to edit or cancel it.',
            subtitle: 'You will find your reservation code in your inbox',
            input_code: 'Code',
            code_not_found: 'The reservation code does not exist',
            button_search: 'Search',
            button_go_back: 'Return',
          },
          reservation_form: {
            title_chunk_1: 'Enter the following data to generate a ',
            title_chunk_2: 'NEW RESERVATION',
            title_chunk_3: 'If you wish to',
            title_chunk_4: 'EDIT OR CANCEL',
            title_chunk_5: 'a existing reservation',
            title_chunk_6: 'click here',
            input_name: 'Names and Surnames',
            input_company_name: 'Company name',
            input_identification: 'Identification number',
            input_identification_or_nit: 'Identification type or NIT',
            input_phone: 'Phone number',
            input_email: 'Email address',
            input_confirm_email: 'Confirm email address',
            input_celebration: 'Do you celebrate something special?',
            input_reason_visit: 'the reason of the visit?',
            input_already_member: 'Already a NOI member?',
            input_number_persons: 'Number of people',
            input_number_pets: 'Number of pets',
            input_location: 'Location',
            input_location_2: 'Locación',
            input_date: 'Date',
            input_hour: 'Hour',
            input_hour_help_1: 'Reservation between {start} and {end}',
            input_block_hour_help: 'No availability between {hours}.',
            input_regular_hour_help: 'Opening hours between {start} and {end}.',
            input_hour_help_1_1: 'Reservation between 12:00 pm and 3:00 pm',
            input_hour_help_1_2: 'Reservation between 12:00 pm and 4:00 pm',
            input_hour_help_2: 'Select time by clicking on the clock icon',
            checkbox_terms_1:
              'I agree to the processing of my personal data in accordance with the terms of the',
            checkbox_terms_2: 'Personal Data Protection Policy',
            checkbox_newsletter:
              'Yes, I would like to receive newsletters and special offers by email.',
            button_submit: 'Book now',
            text_creating_booking: 'Do not close this window, until we load the information.',
            question_cancel: 'Are you sure to cancel this reservation?',
          },
          form_access_blocked: {
            title: 'Open the link from your email again',
            description:
              'To view, change or cancel your booking, go back to the confirmation email from {{company}} and click the link again.',
            why: 'When this page is reloaded the link loses your booking code and stops working. Opening it again from the email fixes it.',
            new_booking: 'Want to make a new booking? You can do it at',
          },
        },
      },
      es: {
        translation: {
          general: {
            select_option: 'Seleccione una opción',
            required: 'Requerido',
            wrong_format: 'No tiene el formato correcto',
            email_not_match: 'Los correos no coinciden',
            button_update: 'Actualizar',
            cancel_reservation: 'Cancelar reserva',
            text_not_close: 'No, cerrar',
            text_yes_cancel: 'Si, cancelar',
            text_updated_reservation: 'Reserva actualizada',
            text_return: 'Regresar',
            text_must_be_number: 'Debe ser un número',
            text_hour_within_schedule: 'La hora debe estar dentro del horario de atención',
            text_cancelled_reservation: 'Reserva cancelada',
          },
          reserve_confirmation: {
            title_chunk_1: 'Hola',
            title_chunk_2: 'Reserva',
            title_chunk_3: 'confirmada para el día',
            text_email_sent: `Hemos enviado un correo electrónico confirmando 
            tu reserva, si no lo visualizas en tu bandeja de entrada, revisa tu 
            carpeta de SPAM y márcalo como un correo deseado`,

            text_reservation_summary: 'Tu reserva ha sido confirmada',
            text_reservation_code: 'Código de reserva',
            text_day: 'Día',
            text_hour: 'Hora',
            text_location: 'Ubicación',
            text_people: 'Personas',
            text_share_whatsapp: 'Compartir en Whatsapp',
            calendar_add: 'Agregar a mi calendario',
            series_title_one: 'Tu reserva ha sido confirmada',
            series_title_many: 'Tienes {{count}} reservas confirmadas',
            series_title_past: 'Tus reservas fueron',
            series_title_none: 'Todas las fechas de esta serie están canceladas',
            series_people_one: '1 persona',
            series_people_many: '{{count}} personas',
            series_all_day: 'todo el día',
            series_code_hint: 'Con el código {{code}} puedes ver, cambiar o cancelar cualquiera de tus fechas.',
            series_cancelled_one: 'No incluye la fecha cancelada: {{dates}}.',
            series_cancelled_many: 'No incluye {{count}} fechas canceladas: {{dates}}.',
            series_past_one: 'Ya realizada: {{dates}}.',
            series_past_many: 'Ya realizadas ({{count}}): {{dates}}.',
            series_share_intro: 'Tus reservas en {{company}}:',
            calendar_pick: 'Elige tu calendario',
            calendar_google: 'Google Calendar',
            calendar_apple: 'Calendario de Apple',
            calendar_outlook: 'Outlook (personal)',
            calendar_office: 'Outlook / Microsoft 365 (empresa)',
            calendar_yahoo: 'Yahoo Calendar',
            calendar_ics: 'Descargar archivo (.ics)',
            calendar_ics_hint: 'Para cualquier otra aplicación de calendario',
            calendar_series: 'Esta reserva se repite {{count}} veces. El archivo .ics añade todas las fechas de una vez; las demás opciones solo esta.',
            calendar_downloaded: 'Archivo listo. Ábrelo para añadir la reserva a tu calendario.',
            calendar_cancelled: 'Esta reserva está cancelada. El archivo la quita de tu calendario.',
            calendar_iframe_hint: '¿No se descargó? Abre tu reserva en una pestaña nueva e inténtalo ahí.',
          },
          search_reservation_form: {
            title: 'Ingresa el código de tu reserva para validarla y poder editarla o cancelarla',
            subtitle: 'Podrás encontrar el código de tu reserva en tu correo electrónico',
            input_code: 'Código',
            button_search: 'Buscar',
            button_go_back: 'Regresar',
            code_not_found: 'El código de reserva no existe',
          },
          reservation_form: {
            title_chunk_1: 'Ingresa los datos a continuación para generar una',
            title_chunk_2: 'NUEVA RESERVA',
            title_chunk_3: 'Si deseas',
            title_chunk_4: 'EDITAR O CANCELAR',
            title_chunk_5: 'una reserva existente',
            title_chunk_6: 'clic aquí',
            input_name: 'Nombres y apellidos',
            input_company_name: 'Nombre de la empresa',
            input_identification: 'Cédula',
            input_identification_or_nit: 'Cédula o NIT',
            input_phone: 'Celular',
            input_email: 'Email address',
            input_confirm_email: 'Confirmar email',
            input_celebration: '¿Celebras algo especial?',
            input_reason_visit: 'Motivo de la visita:',
            input_already_member: '¿Ya eres miembro de NOI?',
            input_number_persons: 'Número de personas',
            input_number_pets: 'Número de mascotas',
            input_location: 'Ubicación',
            input_location_2: 'Locación',
            input_date: 'Fecha',
            input_hour: 'Hora',
            input_hour_help_1: 'Separa entre las {start} y las {end}',
            input_block_hour_help: 'No hay disponibilidad entre {hours}.',
            input_regular_hour_help: 'Horario de atención regular {start} - {end}.',
            input_hour_help_1_1: 'Separa entre las 12:00 pm y las 3:00 pm',
            input_hour_help_1_2: 'Separa entre las 12:00 pm y las 4:00 pm',
            input_hour_help_2: 'Seleccione la hora haciendo clic en el icono del reloj',
            checkbox_terms_1: 'Acepto el tratamiento de mis datos conforme a los términos de la',
            checkbox_terms_2: 'Política de Protección de Datos Personales.',
            checkbox_newsletter:
              'Sí, me gustaría recibir boletines y ofertas especiales por correo electrónico.',
            button_submit: 'Reservar ahora',
            text_creating_booking: 'No cierres esta ventana, hasta que carguemos la información',
            question_cancel: '¿Estás seguro de cancelar esta reserva?',
          },
          form_access_blocked: {
            title: 'Vuelve a abrir el enlace de tu correo',
            description:
              'Para consultar, modificar o cancelar tu reserva, entra de nuevo al correo de confirmación de {{company}} y haz clic otra vez en el enlace.',
            why: 'Al recargar esta página el enlace pierde el código de tu reserva y deja de funcionar. Abrirlo de nuevo desde el correo lo soluciona.',
            new_booking: '¿Quieres hacer una reserva nueva? Puedes hacerla en',
          },
        },
      },
    },
    debug: true,
    lng: 'en', // if you're using a language detector, do not define the lng option
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });
